import { Map } from 'immutable';
import defaultFormReducer from '../../defaultFormReducer';
import { formsNames } from '../../../enums/formsNames';
import {actionTypes as actionTypes} from '../../../actions/Administration/MatSettingsPage/qplFormActions';

let defaultState = {
  loading: false,
  formData: null,
  qplId: null,
};

export default function (state = Map(defaultState), action) {
  switch (action.type) {
    case actionTypes.QPL_FORM_SET_QPL_ID:
      return state.set('qplId', action.payload);
    default:
      return defaultFormReducer(state, action, formsNames.QPL_FORM, defaultState);
  }
}
